import { Store } from "vuex";
import { computed, Ref } from "@vue/composition-api";
import { IRootState } from "./types";
import { Gender } from "../types/gender";
import { Sex } from "drinkaware-tools-api-library/dist/src/clients/users/src";
import { isObject } from "@dcc/common/isObject";

export function saveToGtm({
  state,
  eventName,
  request,
  action
}: {
  state: IRootState;
  eventName: string;
  request: any;
  action: string;
}) {
  try {
    const requestObj = isObject(request) ? request : {};
    if (state.$gtm) {
      state.$gtm.trackEvent({
        event: eventName,
        type: "data",
        action: action,
        category: "drinkfreedays",
        value: request,
        ...requestObj
      });
    }
  } catch (e) {
    // GTM errors should not block anything else
    // eslint-disable-next-line no-console
    console.log(`Error with gtm.trackEvent: ${e}`);
  }
}

export function buildGetter<Response>(
  store: Store<IRootState>,
  namespace: string,
  name: string
): Readonly<Ref<Readonly<Response>>> {
  const useNamespace = namespace === "" ? "" : `${namespace}/`;
  return computed<Response>(() => store.getters[`${useNamespace}${name}`]);
}

export function buildAction<Input>(
  store: Store<IRootState>,
  namespace: string,
  actionName: string
): (input: Input) => any {
  return (input: Input) => {
    const useNamespace = namespace === "" ? "" : `${namespace}/`;
    store.dispatch(`${useNamespace}${actionName}`, input);
  };
}

export function AppGenderToApiSex(gender: Gender): Sex {
  switch (gender) {
    case Gender.Male:
      return "Male";
    case Gender.Female:
      return "Female";
  }
}

export function QueryParamToAppGender(
  value: string | number | (string | null)[] | undefined
): Gender | undefined {
  switch (value) {
    case "Male":
    case "male":
    case "0":
    case 0:
      return Gender.Male;
    case "Female":
    case "female":
    case "1":
    case 1:
      return Gender.Female;
    default:
      return undefined;
  }
}
